// extracted by mini-css-extract-plugin
module.exports = {"NominateArtifact":"NominateResource_NominateArtifact__bOR_r","dialogTitle":"NominateResource_dialogTitle__1mP9T","dialogTitleText":"NominateResource_dialogTitleText__4hlcY"};